import { GETREQUESTOPTIONS, instance } from '../apiService';
import type { Facility } from '../../components/facilities/utils/utils';

export interface CreateFacilityInput {
    name: string;
    licenses: number;
    isTrial: boolean;
    region: string;
    startDate?: string;
    endDate?: string;
    featureAccess?: string[];
}

export interface UpdateFacilityInput {
    name?: string;
    region?: string;
    featureAccess?: string[];
    address_id?: string;
    isTrial?: boolean;
    start_date?: string;
    end_date?: string;
    licenses?: number;
}

export const getAllFacilities = async (): Promise<Facility[]> => {
    const res = await instance.get(
        '/api/department/admin/all',
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const getFacilityById = async (id: string): Promise<Facility> => {
    const res = await instance.get(
        `/api/department/admin/${id}`,
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const createFacility = async (
    input: CreateFacilityInput
): Promise<any> => {
    const res = await instance.post(
        '/api/department/add',
        { department: input },
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const updateFacility = async (
    departmentId: string,
    info: UpdateFacilityInput
): Promise<any> => {
    const res = await instance.post(
        '/api/department/update',
        { departmentId, info },
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export interface FacilityUser {
    _id: string;
    name: string;
    email: string;
    role: string;
    roleId?: string;
    expiryDate: string | null;
    activationDate: string | null;
    deptPermissions?: string[];
    activity?: number | null;
    activityTotal?: number | null;
    createdAt: string;
    isInvite?: boolean;
    sentAt?: string | null;
    reminderSentAt?: string | null;
    lastManualReminderAt?: string | null;
}

export const getFacilityUsers = async (
    departmentId: string
): Promise<FacilityUser[]> => {
    const res = await instance.get(
        `/api/department/admin/${departmentId}/users`,
        GETREQUESTOPTIONS()
    );
    return res.data;
};

export const inviteSiteAdmin = async (
    departmentId: string,
    emails: string[]
): Promise<any> => {
    const res = await instance.post(
        '/api/invitation/create-admin',
        { department_id: departmentId, emails },
        GETREQUESTOPTIONS()
    );
    return res.data;
};
